import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MessageCircle } from "lucide-react";
import logoOutline from "../assets/logo-outline.png";

const wa = (text) => `https://wa.me/393760873342?text=${encodeURIComponent(text)}`;

export const WHATSAPP_URL = wa("Ciao! Vorrei informazioni su torte e ordinazioni.");
export const WA_BRIOSE = wa("Ciao! Ho visto la novità sul sito: vorrei prenotare le Briosé.");
export const WA_TORTE = wa("Ciao! Vorrei prenotare una torta per un evento. Potete aiutarmi?");
export const WA_CATERING = wa("Ciao! Vorrei informazioni sui box catering per una festa.");
export const WA_BOX_CLASSICA = wa("Ciao! Vorrei ordinare la Box Apericena (40 €).");
export const WA_BOX_LUXURY = wa("Ciao! Vorrei ordinare la Box Apericena Luxury (50 €).");

const LINKS = [
  { label: "Novità", href: "#novita", testid: "nav-link-novita" },
  { label: "La Storia", href: "#storia", testid: "nav-link-storia" },
  { label: "Assortimento", href: "#prodotti", testid: "nav-link-prodotti" },
  { label: "Torte", href: "#torte", testid: "nav-link-torte" },
  { label: "Contatti", href: "#contatti", testid: "nav-link-contatti" },
];

export const scrollToSection = (e, href) => {
  e.preventDefault();
  if (window.location.pathname !== "/") {
    window.location.href = "/" + href;
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -70 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-[#fbf6f1]/90 backdrop-blur-md border-b border-[#e6dacb]/80"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[76px] flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => scrollToSection(e, "#top")}
          data-testid="nav-logo-link"
          aria-label="Torna all'inizio"
          className="shrink-0"
        >
          <img
            src={logoOutline}
            alt="Pasticceria San Vigilio"
            className="h-12 w-auto"
            data-testid="brand-logo"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Navigazione principale">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              onClick={(e) => scrollToSection(e, l.href)}
              className="text-[0.8rem] font-medium text-black/60 hover:text-[#84232a] transition-colors duration-300 tracking-[0.08em] uppercase"
            >
              {l.label}
            </a>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta"
            className="group flex items-center gap-2 border border-[#84232a] text-[#84232a] text-[0.8rem] font-medium px-5 py-2.5 rounded-full hover:bg-[#84232a] hover:text-[#fbf6f1] transition-colors duration-300 tracking-wide"
          >
            <MessageCircle className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" />
            Prenota su WhatsApp
          </a>
        </nav>

        <button
          className="lg:hidden p-2 text-black"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label={open ? "Chiudi menu" : "Apri menu"}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden border-t border-[#e6dacb]"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5 bg-[#fbf6f1]">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-${l.testid}`}
                  onClick={(e) => {
                    scrollToSection(e, l.href);
                    setOpen(false);
                  }}
                  className="text-sm font-medium text-black/75 uppercase tracking-[0.1em]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-nav-whatsapp-cta"
                className="flex items-center justify-center gap-2 bg-[#84232a] text-[#fbf6f1] text-sm font-medium px-5 py-3 rounded-full mt-2"
              >
                <MessageCircle className="w-4 h-4" />
                Prenota su WhatsApp
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
